import { Grid } from '@material-ui/core'
import React from 'react'
import './styles/Logo.css';
export const Logo = () => {
    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
        >
            <Grid
                item
            >
                <div className="logo" ></div>
            </Grid>

        </Grid>
    )
}
